module.exports = __webpack_public_path__ + "media/medicine_syrup_dosing_syringe_slide_with_no_syrup_inside.bb592763.mp3";